module.exports = __webpack_public_path__ + "img/Thank You.42049b28.png";